import React from 'react';
import PropTypes from 'prop-types';

import './EmployerMarketingSubnav.scss';
import { Consumer as PageConsumer } from '../../../../contexts/PageContext';
import SectionTabHeader from '../../../Elements/SectionTabHeader/SectionTabHeader';

export default class EmployerMarketingSubnav extends React.PureComponent {
    render() {
        return (
            <div className="component-Employer-Marketing-EmployerMarketingSubnav">
                <PageConsumer>
                    {({ pageProps }) => {
                        const menuItems = [
                            {
                                name: 'Overview',
                                url: '/employers',
                            },
                            {
                                name: 'Resources',
                                url: '/employers-resources',
                            },
                            {
                                name: 'Claim Your Company',
                                url: '/employers-claim-company',
                            },
                            {
                                name: 'Learn More',
                                onClick: this.props.handleDemoButtonClick,
                            },
                        ];

                        return (
                            <SectionTabHeader
                                className="nav-section"
                                mobileMenuItems={menuItems}
                                desktopMenuItems={menuItems}
                                pagePath={pageProps.url && pageProps.url.path}
                                defaultActive="Resources"
                            />
                        );
                    }}
                </PageConsumer>
            </div>
        );
    }
}

EmployerMarketingSubnav.propTypes = {
    /**
     * handler for displaying demo modal
     */
    handleDemoButtonClick: PropTypes.func,
};

EmployerMarketingSubnav.defaultProps = {
    /**
     * handler for displaying demo modal
     */
    handleDemoButtonClick: () => {},
};
